import { useExitFeeValue } from 'components/direct-sales/quote/hooks/useExitFees';

type ExitFeeProps = {
  product?: object;
};

export const ExitFee = ({ product }: ExitFeeProps) => {
  const { short: exitFee } = useExitFeeValue(product);

  return exitFee;
};
